(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-choice-button.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-choice-button.js');
"use strict";

const RadioButton = svs.ui.reactForm.RadioButton;
const HighscoreContext = svs.components.marketplaceCompetition.routeResult.highscore.HighscoreContext;
const _React = React,
  useContext = _React.useContext;
const HighscoreChoiceButton = _ref => {
  let choiceType = _ref.type,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  const _useContext = useContext(HighscoreContext),
    type = _useContext.type,
    changeType = _useContext.changeType;
  return React.createElement(RadioButton, {
    checked: choiceType === type,
    disabled: disabled,
    onChange: () => {
      changeType(choiceType);
    },
    value: choiceType
  }, children);
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.HighscoreChoiceButton', HighscoreChoiceButton);

 })(window);